import { configureStore } from "@reduxjs/toolkit";
import authenticationReducer from "./slices/AuthenticationSlice";
import currentNavReducer from "./slices/CurrentNavSlice";
import challanReducer from "./slices/ChallanSlice";
import referenceReducer from "./slices/ReferenceDataSlice";
import resourcesReducer from "./slices/ResourcesSlice";
import snackbarReducer from "./slices/SnackbarSlice";

const store = configureStore({
  reducer: {
    authentication: authenticationReducer,
    currentNav: currentNavReducer,
    challan: challanReducer,
    reference: referenceReducer,
    resources: resourcesReducer,
    snackbar: snackbarReducer,
  },
});
export default store;
